import React, { useState, useEffect, memo } from 'react'
import DropFile from '../../../../../../../Components/Common/DropFıle'
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { highlightDynamicTexts, removeHighlightDynamicTexts, removePosterDynamicTextTag, removeVideoDynamicTextTag, setCreativesDynamicText, setDynamicTextTag } from '../../../../../../../slices/campaigns/thunk';
import { setActiveDynamicText, setDynamicText, setDynamicVideoError, setSelectedCreative } from '../../../../../../../slices/campaigns/reducer';
import { Row, Col } from 'reactstrap';
import { getHeightAndWidthFromDataUrl } from '../../../../../../../slices/helper';

// function DynamicVideo({ item, idx, value, poster, scrollableNodeRef }) {
const DynamicVideo = memo(({ item, idx, value, poster, scrollableNodeRef }) => {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    currentVersion: state.Campaign.currentVersion,
    dynamicText: state.Campaign.dynamicText,
    activeDynamicText: state.Campaign.activeDynamicText,
    connectedFeed: state.Campaign.connectedFeed,
    creatives: state.Campaign.creatives,
    selectedCreative: state.Campaign.selectedCreative,
  }));
  const {
    currentVersion,
    dynamicText,
    activeDynamicText,
    connectedFeed,
    creatives,
    selectedCreative
  } = useSelector(selectStates);
  const [isComponentVisible, setIsComponentVisible] = useState(false);
  const [pixelSize, setPixelSize] = useState("");
  const [videoPreview, setVideoPreview] = useState(value);
  const [posterPreview, setPosterPreview] = useState(poster);

  useEffect(() => {
    setVideoPreview(value);
  }, [value]);

  useEffect(() => {
    setPosterPreview(poster);
  }, [poster]);

  async function loadVideo(file) {
    return new Promise((resolve, reject) => {
      if (file[0].type.includes("video")) {
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = async () => {
          let encoded = reader.result;
          if (dynamicText.find(item => (item.isCreative === true) && (item.creativeId === selectedCreative._id))) {
            const updatedDynamicText = await dispatch(setDynamicTextTag({ ...item, value: encoded, poster: (item.poster || ''), posterFile: (item.posterFile || ''), file: file[0] }));
            // dispatch(setActiveDynamicText(null));
            // dispatch(setActiveDynamicText(updatedDynamicText));
            setVideoPreview(null);
            setTimeout(() => {
              setVideoPreview(encoded);
            }, 1);
          } else {
            const newTexts = [];
            dynamicText[0].texts.forEach(dItem => {
              if (dItem.tag === item.tag) {
                newTexts.push({ ...dItem, value: encoded, file: file[0], poster: (item.poster || ''), posterFile: (item.posterFile || '') });
              } else {
                newTexts.push({ ...dItem });
              }
            });
            const newDynamicTextObj = { ...dynamicText[0], texts: newTexts, isCreative: true, creativeId: selectedCreative?._id };
            delete newDynamicTextObj._id;
            delete newDynamicTextObj.id;
            dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
            dispatch(setActiveDynamicText(newDynamicTextObj));
          }
          dispatch(setCreativesDynamicText());
          // setPixelSize(await getHeightAndWidthFromDataUrl(encoded))
          resolve(encoded);
        };
      }
    })
  }

  async function loadPoster(file) {
    return new Promise((resolve, reject) => {
      if (file[0].type.includes("image")) {
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = async () => {
          let encoded = reader.result;
          if (dynamicText.find(item => (item.isCreative === true) && (item.creativeId === selectedCreative._id))) {
            dispatch(removePosterDynamicTextTag({ ...item }));
            const updatedDynamicText = await dispatch(setDynamicTextTag({ ...item, poster: encoded, posterFile: file[0], value: (item.value || ''), file: (item.file || '') }));
            // dispatch(setActiveDynamicText(null));
            // dispatch(setActiveDynamicText(updatedDynamicText));
            setPosterPreview(null);
            setTimeout(() => {
              setPosterPreview(encoded);
            }, 1);
          } else {
            const newTexts = [];
            dynamicText[0].texts.forEach(dItem => {
              if (dItem.tag === item.tag) {
                newTexts.push({ ...dItem, value: (item.value || ''), file: (item.file || ''), poster: encoded, posterFile: file[0], });
              } else {
                newTexts.push({ ...dItem });
              }
            });
            const newDynamicTextObj = { ...dynamicText[0], id: null, texts: newTexts, isCreative: true, creativeId: selectedCreative?._id };
            delete newDynamicTextObj._id;
            delete newDynamicTextObj.id;
            dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
            dispatch(setActiveDynamicText(newDynamicTextObj));
          }
          dispatch(setCreativesDynamicText());
          // setPixelSize(await getHeightAndWidthFromDataUrl(encoded))
          resolve(encoded);
        };
      }
    });
  }

  function highlightImage() {
    setIsComponentVisible(true);
    dispatch(highlightDynamicTexts(item.tag));
  };

  function removeHighlight() {
    setIsComponentVisible(false);
    dispatch(removeHighlightDynamicTexts());
  }

  function convertDynamicImage() {
    let prevDynamicText = [];
    let currentDynamicText = {};
    if (activeDynamicText.isCreative) {
      const foundDynamicText = dynamicText.find(item => item.isCreative && item.creativeId === activeDynamicText.creativeId);
      if (foundDynamicText) {
        prevDynamicText = foundDynamicText;
      }
    } else if (activeDynamicText.isCreative === false) {
      prevDynamicText = dynamicText[0];
    }
    const texts = [];
    prevDynamicText.texts.forEach((textItem, textIdx) => {
      if (textIdx === idx) {
        texts.push({ ...textItem, type: 'image', value: '' });
      } else {
        texts.push(textItem);
      }
    });
    const keys = Object.keys(prevDynamicText);
    keys.forEach(dKey => {
      if (dKey !== 'texts') {
        currentDynamicText[dKey] = prevDynamicText[dKey];
      }
    })


    currentDynamicText.texts = texts;
    const updatedDynamicTexts = [];
    dynamicText.forEach((dItem, dIdx) => {
      if (currentDynamicText.isCreative) {
        if (dItem.creativeId === currentDynamicText.creativeId) {
          updatedDynamicTexts.push(currentDynamicText);
        } else {
          updatedDynamicTexts.push(dItem);
        }
      } else {
        if (dIdx === 0) {
          updatedDynamicTexts.push(currentDynamicText);
        } else {
          updatedDynamicTexts.push(dItem);
        }
      }
    })

    if (activeDynamicText.isCreative) {
      dispatch(setDynamicText(updatedDynamicTexts));
      dispatch(setActiveDynamicText(null));
      setTimeout(() => {
        dispatch(setActiveDynamicText(currentDynamicText));
      }, 1);
    } else {
      const newDynamicTextObj = { ...dynamicText[0], texts: texts, isCreative: true, creativeId: selectedCreative._id };
      delete newDynamicTextObj._id;
      delete newDynamicTextObj.id;
      dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
      dispatch(setActiveDynamicText(null));
      setTimeout(() => {
        dispatch(setActiveDynamicText(newDynamicTextObj));
      }, 1);
    }


    if (scrollableNodeRef.current) {
      setTimeout(() => {
        scrollableNodeRef.current.scrollTop = 0
      }, 2);
    }

    removePosterObjAfterConvertImage();
  }

  function removePosterObjAfterConvertImage() {
    if (selectedCreative) {
      let clonedCreative = JSON.parse(JSON.stringify(selectedCreative));
      const elIds = Object.keys(clonedCreative.figmaObject.node);
      let i = 0;
      do {
        const key = elIds[i];
        if (clonedCreative.figmaObject.node[key].hasOwnProperty('name')) {
          if (cleanString(clonedCreative.figmaObject.node[key].name) === cleanString(item.name)) {
            if (clonedCreative.figmaObject.node[key]?.originalImages) {
              try {
                clonedCreative.figmaObject.node[key].bgimages["1x"] = clonedCreative.figmaObject.node[key].originalImages["1x"];
                clonedCreative.figmaObject.node[key].bgimages["2x"] = clonedCreative.figmaObject.node[key].originalImages["1x"];
                delete clonedCreative.figmaObject.node[key].originalImages;
              } catch (error) {
                // console.log('error', error);
              }
            }
          }
        }
        i++;
      } while (i < elIds.length);
      dispatch(updateCreatives({ ...clonedCreative, preview: selectedCreative?.preview }));
      dispatch(updateScrolledCreatives({ ...clonedCreative, preview: selectedCreative?.preview }));
    }
  }


  function removePoster() {
    dispatch(removePosterDynamicTextTag({ ...item }));
    dispatch(setActiveDynamicText(activeDynamicText));
    setPosterPreview(null);
  }

  function removeVideo() {
    dispatch(removeVideoDynamicTextTag({ ...item }));
    dispatch(setActiveDynamicText(activeDynamicText));
    setVideoPreview(null);
  }
  return (
    <div className={isComponentVisible ? 'selected-dynamic-item dynamic-item' : 'dynamic-item'} onMouseOver={highlightImage} onMouseOut={removeHighlight}>
      <div className='d-flex flex-row align-items-center justify-content-between mb-1'>
        <div className='w-100 text-truncate d-flex align-items-center'>
          <i className='bx bx-movie-play fs-15 me-1'></i>
          <span className='w-auto text-truncate me-1' style={{ maxWidth: '100%' }}>{item.name}</span>
          <span className='dynamic-image-size me-2'>{pixelSize}</span>
        </div>
        <div className='d-flex align-items-center gap-1'>
          {posterPreview ?
            <button className='btn btn-icon btn-sm btn-soft-dark' onClick={removePoster}>
              <i className='mdi mdi-image-off-outline fs-15'></i>
            </button>
            : null}
          {videoPreview ?
            <button className='btn btn-icon btn-sm btn-soft-dark' onClick={removeVideo}>
              <i className='mdi mdi-video-off-outline fs-15'></i>
            </button>
            : null}
          <button className='btn btn-icon btn-sm btn-soft-dark' onClick={convertDynamicImage}>
            <i className='bx bx-image-alt align-bottom fs-15'></i>
          </button>
        </div>
      </div>
      <div className='w-100 d-flex align-items-center justify-content-center'>
        <Row className='w-100 p-0'>
          {videoPreview ?
            <Col
              className={'p-0 ps-1 my-auto d-flex align-items-center justify-content-center'}
              style={{ height: '125px', pointerEvents: 'none' }}
            >
              <video className='w-100 h-100' style={{ pointerEvents: 'none' }} muted autoPlay="true">
                <source src={videoPreview}></source>
              </video>
            </Col>
            : null}
          <Col className='p-0 ps-1 d-flex align-items-center justify-content-center'>
            <DropFile handleUpload={async (file) => await loadVideo(file)} size='sm' message='Drag & Drop your video or Browse' />
          </Col>
          {posterPreview ?
            <Col className='p-0 ps-1 d-flex align-items-center justify-content-center'>
              <img className='w-100' src={posterPreview} style={{ height: '125px', objectFit: 'contain' }} />
            </Col>
            : null}
          <Col className='p-0 ps-1 d-flex align-items-center justify-content-center'>
            <DropFile handleUpload={async (file) => await loadPoster(file)} size='sm' message='Drag & Drop your video poster or Browse' />
          </Col>
        </Row>
      </div>
    </div>
  )
})

export default DynamicVideo
